import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

export const DataCollectionInProgressBannerWrapper = styled(Flex)`
    width: 100%;
    margin-bottom: 32px;
`;
